import React, { useState, useEffect } from 'react';
import HomeImage from '../assets/homeImage.jpg';
import '../css/main.css';
import "../css/style.css";
import "../css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import OwlCarousel from 'react-owl-carousel';
import fallbackImage from '../assets/fallback.jpg';

const Home = () => {
    const [products, setProducts] = useState([]);
    const [content, setContent] = useState([]);
    const [imageDirectory, setImageDirectory] = useState('');
    const [docsDirectory, setDocsDirectory] = useState('');
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    const bearerToken = localStorage.getItem('bearerToken');
    const navigate = useNavigate();

    useEffect(() => {
        const initialize = async () => {
            try {
                await authenticateUser();

                const [dirs, cats, productsList] = await Promise.all([
                    getDirectories(),
                    fetchCategories(),
                    fetchProducts()
                ]);

                await runImageCheck();

                setImageDirectory(dirs?.imgDirectory || '');
                setDocsDirectory(dirs?.docsDirectory || '');
                setCategories(Array.isArray(cats) ? cats : []);
                setProducts(Array.isArray(productsList) ? productsList : []);
                setContent(Array.isArray(productsList) ? productsList : []);
            } catch (error) {
                console.error('Initialization error:', error);
            } finally {
                setLoading(false);
            }
        };

        initialize();
    }, []);

    const authenticateUser = async () => {
        try {
            await axios.get("/Website/MHEWebsiteLogin", {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${bearerToken}`,
                },
            });
        } catch (error) {
            console.error('Authentication error:', error);
        }
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.get('/Website/GetCategories', {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });
            return response.data || [];
        } catch (error) {
            console.error('Error fetching categories:', error);
            return [];
        }
    };

    const fetchProducts = async () => {
        try {
            const response = await axios.get('/Website/getProducts', {
                headers: { Authorization: `Bearer ${bearerToken}` },
            });
            return response.data || [];
        } catch (error) {
            console.error('Error fetching products:', error);
            return [];
        }
    };

    const runImageCheck = async () => {
        try {
            await axios.get("/Website/CheckAndCopyBlobStorageToWebsite", {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${bearerToken}`,
                },
            });
        } catch (error) {
            console.error('Image check error:', error);
        }
    };

    const getDirectories = async () => {
        try {
            const response = await axios.get("/Website/GetDirectories", {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${bearerToken}`,
                },
            });
            return response.data || { imgDirectory: '', docsDirectory: '' };
        } catch (error) {
            console.error('Error fetching directories:', error);
            return { imgDirectory: '', docsDirectory: '' };
        }
    };

    const navToPage = (page, category) => {
        if (!Array.isArray(products) || !Array.isArray(categories)) return;

        const sortedProducts = [...products].sort((a, b) => {
            const aHasNx = a?.proD_NAME?.toLowerCase().includes("nx") ? 0 : 1;
            const bHasNx = b?.proD_NAME?.toLowerCase().includes("nx") ? 0 : 1;
            return aHasNx - bHasNx || (a?.proD_NAME || '').localeCompare(b?.proD_NAME || '');
        });

        navigate(page, { state: { cat: categories, products: sortedProducts, selCat: category } });
    };

    return (
        <div className="fullscreen-image">
            <img src={HomeImage} alt="Home" />
            <h1 className="featured-products-banner">Featured Products</h1>

            <div className="carousel">
                <div className="product-container">
                    {loading ? (
                        <div className="text-center my-5">
                            <p style={{ fontSize: '1.2rem', color: '#000000' }}>Loading featured products...</p>
                        </div>
                    ) : (
                        Array.isArray(products) &&
                        products.length > 0 &&
                        imageDirectory && (
                            <OwlCarousel
                                className="owl-theme"
                                loop
                                margin={0}
                                nav
                                dots={false}
                                responsive={{
                                    0: { items: 1 },
                                    600: { items: 2 },
                                    1000: { items: 4 },
                                }}
                            >
                                {products
                                    .filter(p => p?.proD_NAME)
                                    .sort((a, b) => {
                                        const aHasNX = a.proD_NAME.includes("NX") ? 1 : 0;
                                        const bHasNX = b.proD_NAME.includes("NX") ? 1 : 0;
                                        return bHasNX - aHasNX;
                                    })
                                    .map((product, index) => (
                                        <Link
                                            key={product.id || `product-${index}`}
                                            className="product-link item"
                                            to={`/ProdView/${product.proD_NAME}`}
                                            state={{
                                                imgDirectory: imageDirectory,
                                                docsDirectory: docsDirectory,
                                                prod: product
                                            }}
                                        >
                                            <div className="product" onClick={() => navToPage('/Products', 0)}>
                                                <img
                                                    src={`${imageDirectory}/${product.imG_PATH || 'default.jpg'}`}
                                                    alt={product.proD_NAME}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = fallbackImage;
                                                    }}
                                                />
                                                <h2>{product.proD_NAME}</h2>
                                            </div>
                                        </Link>
                                    ))}
                            </OwlCarousel>
                        )
                    )}
                </div>
            </div>

            {/* Footer */}
            <footer className="text-light pt-5 mt-5 pb-5 mb-5" style={{ backgroundColor: 'black' }}>
                <div className="container">
                    <div className="row g-4">
                        {/* Company Info */}
                        <div className="col-md-3 text-md-start mb-3 mb-md-0">
                            <p className="mb-0">&copy; {new Date().getFullYear()} MHE Electronics</p>
                            <p className="mb-0">All Rights Reserved</p>
                        </div>

                        {/* South Africa Office */}
                        <div className="col-md-4">
                            <h5 className="text-light mb-3">South Africa</h5>

                            <div className="d-flex mb-2">
                                <i className="fa fa-map-marker-alt text-light me-3 mt-1" style={{ width: "20px"}}></i>
                                <span>49 Alexander Road, Westmead, Pinetown, KZN, 3608</span>
                            </div>

                            <div className="d-flex mb-2">
                                <i className="fa fa-phone-alt text-light me-3 mt-1" style={{ width: "20px"}}></i>
                                <span>+27 31 780 2560</span>
                            </div>

                            <div className="d-flex mb-2">
                                <i className="fa fa-envelope text-light me-3 mt-1 mt-1" style={{ width: "20px"}}></i>
                                <a href="mailto:sales@mhe.co.za" className="text-light text-decoration-none">sales@mhe.co.za</a>
                            </div>
                        </div>

                        {/* UK Office */}
                        <div className="col-md-5">
                            <h5 className="text-light mb-3">United Kingdom</h5>

                            <div className="d-flex mb-2">
                                <i className="fa fa-map-marker-alt text-light me-3 mt-1" style={{ width: "20px"}}></i>
                                <span>Fairstead House, Erratts Hill, Cowlinge, Newmarket, CB8 9QD</span>
                            </div>

                            <div className="d-flex mb-2">
                                <i className="fa fa-phone-alt text-light me-3 mt-1" style={{ width: "20px"}}></i>
                                <span>+44 1440 820381</span>
                            </div>

                            <div className="d-flex mb-2">
                                <i className="fa fa-envelope text-light me-3 mt-1" style={{ width: "20px"}}></i>
                                <a href="mailto:mike@mheuk.co.uk" className="text-light text-decoration-none">mike@mheuk.co.uk</a>
                            </div>
                        </div>

                    </div>
                </div>
            </footer>

        </div>
    );
};

export default Home;
